export default "__VITE_ASSET__DOkbHkbr__"